/*
 * @Author: 冯嘉妍 alice1@gm99.com
 * @Date: 2025-12-03 11:29:22
 * @LastEditors: 冯嘉妍 alice1@gm99.com
 * @LastEditTime: 2026-05-20 11:15:38
 * @FilePath: /resource_gssr.37games.com/src/resource/plugins/biPoint/define.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const UPLOAD_TYPE = {
  sdkstore: 'sdkstore', // 旧版支付页
  webstorev1: 'webstorev1', // 新版礼包支付页
  webstorev2: 'webstorev2', // 新版代币支付页
  webstorev3: 'webstorev3', // v3支付页
  webstorev35: 'webstorev35', // v3.5支付页
  h5store: 'h5store', // H5支付页
  creditpay: 'creditpay', // 信用卡支付页
  officialPassport: 'officialPassport', // 新版用户中心
  passport: 'passport', // 旧版用户中心
  csorder: 'csorder', // 新版客服工单
  dma: 'dma', // dma弹窗
  userAgreement: 'userAgreement', // 用户协议弹窗
  webstorev0: 'webstorev0' // 3syua支付页
};
